import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/not-found.js");
